import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import {Container} from './styles'
import api from '../../services/api'
import Settings from '../../assets/emojis/settings/chart-increasing.png'
import User from '../../assets/emojis/aval/user.png'
import Hand from '../../assets/emojis/aval/hand.png'
import moment from 'moment'

moment.locale('pt-br')

const RelatorioVendas = () => {

    const params = useParams()

    const [data, setData] = useState([])
    const [totalVenda, setTotalVenda] = useState(0)
    const [totalProdutos, setTotalProdutos] = useState(0)
    const [taxaEntrega, setTaxaEntrega] = useState(0)
    const [desconto, setDesconto] = useState(0)
    const [itensPedido, setItensPedido] = useState([])
    const [chat, setChat] = useState([])
    const [retirada, setRetirada] = useState(false)

    const getVenda = async () => {

        const token = await localStorage.getItem('@jwt')
        api.post('/api/relatorios/vendas', { chave_pedido: params.chave_pedido } ,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => {

            console.log("getVenda", res.data.result)


            if(res.data.data === true){
                console.log(res.data.result.retirada)
                setRetirada(res.data.result.retirada)
                setData(res.data.result)
                setItensPedido(res.data.result.itens_pedido)
                setChat(res.data.result.chat)
                setTotalVenda(res.data.result.total_venda)
                setTotalProdutos(res.data.result.total_produtos)
                setTaxaEntrega(res.data.result.taxa_entrega)
                setDesconto(res.data.result.desconto)
            }

        }).catch(async e => {
            console.log(e)
        })
    }

    useEffect(() => {
        getVenda()
    }, [])

    // Ordenar as mensagens do chat por data e hora
    const sortedChat = chat.slice().sort((a, b) => {
        const dateA = moment(`${a.data} ${a.hora}`, 'YYYY-MM-DD HH:mm:ss');
        const dateB = moment(`${b.data} ${b.hora}`, 'YYYY-MM-DD HH:mm:ss');
        return dateA - dateB;
    });

    
    return(
        <Container>
            <div className="div-pai">
                <div className="div-rota"> 

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/minhas-vendas'}>
                    <span>
                        Minhas Vendas
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/minhas-vendas/detalhes/:chave_pedido'}>
                    <span>
                        Detalhes
                    </span>
                </Link>

                </div>

                <div className="titulo">
                    <img alt="" className="emoji" src={Settings} />
                
                    <h1>Minhas vendas</h1>

                    <h5>Consulte suas vendas e fique por dentro da operação da sua loja.</h5>
                </div>


                <hr className="linha"/>

                <div className='borda3'>
                    <div className='conteudo'>
                        <img alt="" className="user" src={User} />
                            <div className='coluna'>
                                <span className='userName'>{data.cliente_nome}</span>
                                    <div className='row-mobile'>
                                        <span className='subtexto1'>{data.chave_pedido} ・ </span>
                                        <span className='subtexto1'>{moment(data.data_pedido).format('DD/MM/YYYY')} às {data.hora_pedido}</span>
                                    </div>
                            </div>
                    </div>                        
                </div>

                <div className='borderPink'>
                    <div>
                        <img alt="" className="hand" src={Hand} />
                    </div>
                    <span className='coments'>Em conformidade com a LGPD (Lei Geral de Proteção de Dados), nossa Política de Privacidade estabelece o parâmetro de não exibição de algumas
                    informações após a finalização do pedido.
                    </span>
                </div>

                <div className='row1'>
                    <div className='borda'>
                        <div>
                            <span className='nota'>Pedido</span>
                            <div className='star'>
                                <span>Pedido feito em {moment(data.data_pedido).format('DD/MM/YYYY')} às {data.hora_pedido}</span>
                            </div>
                            <div className='star'>
                                <span>Chave: {data.chave_pedido}</span> 
                            </div>
                            <div className='star'>
                                <span>Situação do pedido: {data.situacao}</span> 
                            </div>
                        </div>
                    </div>

                    <div className='borda'>
                        <div>
                            <span className='nota'>Totais</span>
                            <div className='star'>
                                <span>Total: {Number(totalVenda).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span>
                            </div>
                            <div className='star'>
                                <span>Produtos: {Number(totalProdutos).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span> 
                            </div>
                            <div className='star'>
                                <span>Taxa de entrega: {Number(taxaEntrega).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span> 
                            </div>
                            {/* <div className='star'>
                                <span>Desconto: {Number(desconto).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span> 
                            </div> */}
                        </div>
                    </div>

                    <div className='borda'>
                        <div>
                            <span className='nota'>Pagamento e Entrega</span>
                             
                            <div className='star'>
                                <span>Forma de pagamento: {data.metodo_pagamento} {data.meio_pagamento === null ? '' : data.meio_pagamento}</span>
                            </div>

                            {retirada === false ?
                            <>
                                <div className='star'>
                                    <span>Endereço: {data.endereco}</span> 
                                </div>
                                <div className='star'>
                                    <span>Bairro: {data.bairro}</span> 
                                </div>
                                <div className='star'>
                                    <span>Complemento: {data.complemento}</span> 
                                </div>
                            </>
                            :
                            <div className='star'>
                                <span>Retirada na loja</span>
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className='borda4'>
                    <div className='coluna'>
                        <span className='nota'>Comentário</span>
                            <div className='star'>
                                <span>
                                    { data.comentario }
                                </span>       
                            </div>
                    </div>                     
                </div>

                <hr className="linha"/>

                <div className='titulo'>
                    <h2>Itens do pedido</h2>
                </div>

                {itensPedido.length > 0 && itensPedido.map(item => 
                    <div className='borda5' key={item.id}>
                        <div className='card-item'>
                            <div className="meio">
                                <span className="title1">Qtde</span>
                                <span className="title2-qtde">{ item.quantidade }</span>
                            </div>
                                <div className="meio">
                                <span className="title1">Nome</span>
                                <span className="title2">{ item.nome }</span>
                            </div>
                            <div className="meio">
                                <span className="title1">Categoria</span>
                                <span className="title2">{ item.categoria }</span>
                            </div>
                            <div className="meio">
                                <span className="title1">Descrição</span>
                                <span className="title2-descricao">{ item.descricao }</span>
                            </div>
                            <div className="meio">
                                <span className="title1">Valor Unitário</span>
                                <span className="title2">{Number(item.valor).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span>
                            </div>
                        </div> 

                        {item.listaAdicionais.length > 0 && 
                        <>
                            <div className='title3'>
                                <span>Opções</span>
                            </div>
                            <div className='card-item'>
                                <div className="meio">
                                    <span className="title4">Adicionais</span>
                                    {item.listaAdicionais.map(adicional => 
                                        <span className="title5">{ adicional.itens_adicionais.nome} ({adicional.quantidade}x)</span>
                                    )}
                                    </div>
                            </div>
                        </>
                        }
                    </div>
                )}


                {/* ===================== MOBILE ================== */}
                
                {itensPedido.length > 0 && itensPedido.map(item =>
                    <div className='borda5-mobile' key={item.id}>
                        <div>
                            <span className='title1-mobile'>Qtde </span>
                            <span className='title2-mobile'>{ item.quantidade }</span>
                        </div>
                        <div>
                            <span className='title1-mobile'>Nome  </span>
                            <span className='title2-mobile'>{ item.nome }</span>
                        </div>
                        <div>
                            <span className="title1-mobile">Categoria </span>
                            <span className="title2-mobile">{ item.categoria }</span>
                        </div>
                        <div>
                            <span className="title1-mobile">Descrição </span>
                            <span className="title2-mobile">{ item.descricao }</span>
                        </div>
                        <div>
                            <span className="title1-mobile">Valor Unitário </span>
                            <span className="title2-mobile">{Number(item.valor).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</span>
                        </div>

                        {item.listaAdicionais.length > 0 && 
                        <>
                            <div className='title3-mobile'>
                                <span>Opções</span>
                            </div>
                                <span className="title4-mobile">Adicionais</span>
                                {item.listaAdicionais.map(adicional => 
                                    <span className="title5-mobile">{ adicional.itens_adicionais.nome} ({adicional.quantidade}x)</span>
                                )}
                        </>
                        }
                    </div>
                )}

                {/* ======================================= */}

                <hr className="linha"/>
                <div className='titulo'>
                    <h2>Histórico do chat</h2>
                </div>

                {/* ===================== MOBILE ================== */}

                {/* {chat.length > 0 && chat.map(item =>   */}
                {sortedChat.length > 0 && sortedChat.map(item => 
                    <div class="messages" key={item.id}>
                        { item.restaurante &&
                            <div class="message customer">
                                <div className='title-message-mobile'>Restaurante</div>
                                { item.restaurante }
                            </div>
                        }
                        { item.cliente &&
                        <div class="message restaurant">
                            <div className='title-message-mobile'>Cliente</div>
                            { item.cliente }
                        </div>
                        }
                        <div className='dataehora-mobile'>{moment(item.data).format('DD/MM/YYYY')} às {item.hora}</div>
                    </div>
                )}
        
                {/* ======================================= */}

                <table>
                    <thead>
                        <tr>
                            <th className='th-drag'>Restaurante</th>
                            <th className='th-img'>Cliente</th>
                            <th className='th-img'>Data e Hora</th>
                        </tr>
                    </thead>
                </table>

                <table>
                    {/* {chat.length > 0 && chat.map(item =>   */}
                    {sortedChat.length > 0 && sortedChat.map(item =>           
                        <tr key={item.id}>
                            <td className='dados'>{ item.restaurante }</td>
                            <td className='dados'>{ item.cliente }</td>
                            <td className='dados'>{moment(item.data).format('DD/MM/YYYY')} às {item.hora}</td>
                        </tr>
                    )}     
                </table>
            </div>
        </Container>
    )
}

export default RelatorioVendas